/**
 * 拼多多
 * 每关: { steps, initialStepId, initialForm }
 * 步骤: id, image, tip, hotspots[], fields[], isEnd, afterEnter?: { delay, go }, onEnter?
 */
function r(path) {
  return require('@/assets/images/pdd/' + path)
}

export function getScenarioConfig() {
  return {
    first: {
      initialStepId: 'desktop',
      initialForm: { name: '', password: '', rnd: '' },
      steps: [
        {
          id: 'desktop',
          image: ({ ui }) => (ui.qnHover ? r('pddbg2.png') : r('pddbg1.png')),
          tip: '请双击<span style="color: red;font-weight:bold;">左侧练习场</span>中的拼多多图标进行登录',
          hotspots: [
            { id: 'qnIcon', x: 0.29, y: 0.26, w: 0.04, h: 0.08, on: 'dblclick', hoverSet: { qnHover: true }, hoverUnset: { qnHover: false }, next: 'login1' }
          ]
        },
        {
          id: 'login1',
          stageBg: () => r('pddbg1.png'),
          image: () => r('login1.png'),
          canvasScale: 0.7,
          tip: '点击<span style="color: red;font-weight:bold;">账号登录</span>',
          hotspots: [
            { id: 'aclg', x: 0.64, y: 0.15, w: 0.09, h: 0.06, next: 'login2' }
          ]
        },
        {
          id: 'login2',
          stageBg: () => r('pddbg1.png'),
          image: ({ ui }) => {
            if (ui.saveChecked) return r('login3.png')
            return r('login2.png')
          },
          canvasScale: 0.7,
          tip: '1.复制粘贴账号和密码<br>2.取消自动登录勾选',
          fields: [
            { id: 'name', model: 'name', type: 'text',bgColor: '#fff', placeholder: '账号名/手机号', x: 0.505, y: 0.38, w: 0.24, h: 0.065 },
            { id: 'pwd', model: 'password', type: 'password',bgColor: '#fff', placeholder: '登录密码', autocomplete: 'new-password', x: 0.505, y: 0.475, w: 0.24, h: 0.065 }
          ],
          hotspots: [
            { id: 'save', x: 0.69, y: 0.66, w: 0.02, h: 0.03, set: { saveChecked: true } },
            {
              id: 'loginBtn',
              x: 0.50, y: 0.57, w: 0.25, h: 0.06,
              guard: ({ form,ui }) => {
                if (!ui.saveChecked) return { ok: false, msg: '不要勾选自动登录' }
                if (!form.name) return { ok: false, msg: '请输入账号' }
                if (form.name !== '淘金云客服:小淘') return { ok: false, msg: '用户名或密码错误，请注意大小写或特殊符号' }
                if (!form.password) return { ok: false, msg: '请输入密码' }
                if (form.password !== 'Tj1234') return { ok: false, msg: '用户名或密码错误，请注意大小写或特殊符号' }
                return { ok: true }
              },
              next: 'rnd'
            }
          ]
        },

        {
          id: 'rnd',
          stageBg: () => r('pddbg1.png'),
          canvasScale: 0.4,
          image: ({ ui }) => {
            if (ui.rndShown) return r('rnd2.png')
            return r('rnd1.png')
          },
          tip: ({ ui }) =>
            ui.rndShown
              ? '短信验证码：<br><span style="color: red;font-weight:bold;">660220</span>'
              : '<span style="color: red;font-weight:bold;">获取短信验证码</span>',
          fields: [
            { id: 'rnd', model: 'rnd', type: 'text',bgColor: '#FFFFFF', placeholder: '输入短信验证码', x: 0.185, y: 0.61, w: 0.32, h: 0.05 }
          ],
          hotspots: [
            { id: 'sendRnd', x: 0.63, y: 0.58, w: 0.20, h: 0.10, set: { rndShown: true } },
            {
              id: 'loginRndBtn',
              x: 0.50, y: 0.85, w: 0.15, h: 0.08,
              guard: ({ form }) => {
                if (!form.rnd) return { ok: false, msg: '请输入短信验证码' }
                if (form.rnd !== '660220') return { ok: false, msg: '短信验证码错误' }
                return { ok: true }
              },
              next: 'done'
            }
          ]
        },
        {
          id: 'done',
          stageBg: () => r('pddbg1.png'),
          image: () => r('loginindex.png'),
          canvasScale: 0.95,
          isEnd: true
        }
      ]
    },
    second: {
      initialStepId: 'offline',
      initialForm: { },
      steps: [
        {
          id: 'offline',
          stageBg: () => r('pddbg1.png'),
          image: () => r('loginindex.png'),
          canvasScale: 0.95,
          tip: '切换接待状态为<span style="color: red;font-weight:bold;">在线</span>',
          extraImages: ({ ui }) => {
            const list = []
            if (ui.offlineClick) {
              list.push({ id:'status', src: r('staus.png'), x:0.13, y:0.1, w:0.06, h:0.1 })
            }
            return list
          },
          hotspots:({ ui }) => { 
            const list = []
            if (!ui.offlineClick) {
               list.push({ id: 'offline', x: 0.13, y: 0.1, w: 0.04, h: 0.03, set: { offlineClick: true } })
            }
            if (ui.offlineClick) {
               list.push({ id: 'online', x: 0.13, y: 0.1, w: 0.04, h: 0.03, next: 'online' })
            }
            return list
          }
        },
        {
          id: 'online',
          stageBg: () => r('pddbg1.png'),
          image: ({ ui }) => (ui.qtHover ? r('statusonline1.png') : r('statusonline.png')),
          tip: '请<span style="color: red;font-weight:bold;">退出登录</span>(鼠标移动到顶部店铺名称后面，点击鼠标<span style="color: red;font-weight:bold;">左键</span>)',
          extraImages: ({ ui }) => {
            const list = []
            if (ui.showQt) {
              list.push({ id:'qtalert', src: r('qtalert.png'), x:0.17, y:0.05, w:0.07, h:0.154 })
            }
            return list
          },
          canvasScale: 0.95,
          hotspots:({ ui }) => { 
              const list = []
              if (!ui.showQt) {
                list.push({ id: 'qtBtn', x: 0.18, y: 0.0, w: 0.04, h: 0.05, hoverSet: { qtHover: true }, hoverUnset: { qtHover: false }, set: { showQt : true } })
              }
              if (ui.showQt) {
                list.push({ id: 'qtBtn2', x: 0.17, y: 0.14, w: 0.07, h: 0.05, next: 'add' })
              }
              return list
          } 
        },
        {
          id: 'add',
          stageBg: () => r('pddbg1.png'),
          image: r('statusonline.png'),
          canvasScale: 0.95,
          tip: '点击<span style="color: red;font-weight:bold;">加号</span>添加账号',
          hotspots:[{ id: 'qtBtn', x: 0.22, y: 0.0, w: 0.04, h: 0.05, next:'end' }],
        },
        {
          id: 'end',
          stageBg: () => r('pddbg1.png'),
          image: r('statusonline1.png'),
          canvasScale: 0.95,
          tip: '点击<span style="color: red;font-weight:bold;">加号</span>添加账号',
          extraImages: [{ id:'qtalert', src: r('login1.png'), x:0.22, y:0.05, w:0.60, h:0.87, shadow: false }],
          isEnd: true 
        },
      ]
    },
    third: {
      initialStepId: 'order1',
      initialForm: { orderid: '' },
      steps: [
        {
          id: 'order1',
          stageBg: () => r('pddbg1.png'),
          image: () => r('statusonline.png'),
          canvasScale: 0.95,
          tip: '切换到<span style="color: red;font-weight:bold;">订单管理</span>页面',
          extraImages: ({ ui }) => {
            const list = []
            if (ui.orderHover) {
              list.push({ id:'orderHover', src: r('order_hover.png'), x:0.023, y:0.13, w:0.03, h:0.03, shadow: false })
            }
            return list
          },
          hotspots:[
            { id: 'order', x: 0.05, y: 0.11, w: 0.04, h: 0.06,hoverSet: { orderHover: true }, hoverUnset: { orderHover: false }, next: 'order2' }
          ]
        },
        {
          id: 'order2',
          stageBg: () => r('pddbg1.png'),
          image: () => r('order1.png'),
          canvasScale: 0.95,
          tip: '搜索订单号为<span style="color: red;font-weight:bold;">8888-88888888888</span>的订单',
          extraImages: [],
          fields: [
            { id: 'orderid', model: 'orderid', type: 'text',bgColor: '#fff', placeholder: '订单号/快递单号', x: 0.68, y: 0.24, w: 0.15, h: 0.02 },
          ],
          hotspots:[
            { 
              id: 'search', 
              x: 0.85, y: 0.23, w: 0.03, h: 0.04, 
              guard: ({ form }) => {
                if (form.orderid !== '8888-88888888888') return { ok: false, msg: '请查询指定订单' }
                return { ok: true }
              },
              next: 'order3' }
          ]
        },
        {
          id: 'order3',
          stageBg: () => r('pddbg1.png'),
          image: () => r('order2.png'),
          canvasScale: 0.95,
          tip: '向下单客户<span style="color: red;font-weight:bold;">发起聊天</span>',
          extraImages: [],
          hotspots:[
            { 
              id: 'chat', 
              x: 0.73, y: 0.43, w: 0.06, h: 0.04, 
              next: 'order4' }
          ]
        },
        {
          id: 'order4',
          stageBg: () => r('pddbg1.png'),
          image: () => r('order3.png'),
          canvasScale: 0.95,
          tip: '向下单客户<span style="color: red;font-weight:bold;">发起聊天</span>',
          extraImages: [],
          isEnd: true
        },
      ]
    },
    four: {
      initialStepId: 'four_step1',
      initialForm: { },
      steps: [
        {
          id: 'four_step1',
          stageBg: () => r('pddbg1.png'),
          image: () => r('order3.png'),
          canvasScale: 0.95,
          tip: '点击<span style="color: red;font-weight:bold;">帮助链接</span>按钮',
          extraImages: ({ ui }) => { 
            const list = []
            if (ui.linkHover) {
              list.push({ id:'linkHover', src: r('link_hover.png'), x:0.36, y:0.73, w:0.04, h:0.03, shadow: false })
            }
            if (ui.linkClick) {
               list.push({ id:'link', src: r('link.png'), x:0.355, y:0.44, w:0.30, h:0.24 })
            }
            return list
          },
          hotspots:({ ui }) => { 
            const list = []
            list.push({ id: 'bq', x: 0.36, y: 0.69, w: 0.02, h: 0.04, hoverSet: {linkHover: true}, hoverUnset: {linkHover: false}, set: { linkClick : true } })
            if (ui.linkClick) {
              list.push({ id: 'sendlink', x:0, y:0, w:1, h:1, next: 'four_step7' })
            }
            return list
          }
        },
        {
          id: 'four_step7',
          stageBg: () => r('pddbg1.png'),
          image: () => r('order3.png'),
          canvasScale: 0.95,
          tip: '点击<span style="color: red;font-weight:bold;">推送优惠券</span>按钮',
          extraImages: ({ ui })  => {
            const list = []
            if (ui.couponHover) {
              list.push({ id:'couponHover', src: r('coupon_hover.png'), x:0.43, y:0.73, w:0.05, h:0.03, shadow: false })
            }
            if (ui.couponlick) {
               list.push({ id:'coupon', src: r('coupon.png'), x:0.36, y:0.53, w:0.28, h:0.14 })
            }
            return list
          },
          hotspots:({ ui })  => {
            const list = []
            list.push({ id: 'couponbtn', x: 0.43, y: 0.69, w: 0.02, h: 0.04, hoverSet: {couponHover: true}, hoverUnset: {couponHover: false}, set: { couponlick: true } })
            if (ui.couponlick) {
              list.push({ id: 'couponbtn2', x:0, y:0, w:1, h:1, next: 'four_step9' })
            }
            return list
          }
        },
        {
          id: 'four_step8',
          stageBg: () => r('pddbg1.png'),
          image: () => r('order3.png'),
          canvasScale: 0.95,
          tip: '点击<span style="color: red;font-weight:bold;">举报恶意售后</span>按钮',
          extraImages: ({ ui })  => {
            const list = []
            if (ui.eyshlick) {
               list.push({ id:'jbeysh', src: r('jbeysh.png'), x:0.24, y:0.1, w:0.44, h:0.77 })
            }
            return list
          },
          hotspots:({ ui })  => {
            const list = []
            if (!ui.eyshlick) {
              list.push({ id: 'eyshbtn', x: 0.45, y: 0.69, w: 0.02, h: 0.04, set: { eyshlick: true } })
            }
            if (ui.eyshlick) {
              list.push({ id: 'eyshbtn2',  x:0.24, y:0.1, w:0.44, h:0.77, next: 'four_step9' })
            }
            return list
          }
        },
        {
          id: 'four_step9',
          stageBg: () => r('pddbg1.png'),
          image: () => r('order3.png'),
          canvasScale: 0.95,
          tip: '点击<span style="color: red;font-weight:bold;">代客户申请售后</span>按钮',
          extraImages: ({ ui })  => {
            const list = []
            if (ui.dkhsqshHover) {
               list.push({ id:'dkhsqshHover', src: r('dkhsqsh_hover.png'), x:0.47, y:0.73, w:0.075, h:0.03, shadow: false })
            }
            if (ui.dkhsqshclick) {
               list.push({ id:'dkhsqsh', src: r('dkhsqsh.png'), x:0.27, y:0.11, w:0.42, h:0.69 })
            }
            return list
          },
          hotspots:({ ui })  => {
            const list = []
            list.push({ id: 'dkhsqshbtn', x: 0.47, y: 0.69, w: 0.02, h: 0.04, hoverSet: { dkhsqshHover: true }, hoverUnset: { dkhsqshHover: false } ,set: { dkhsqshclick: true } })
            if (ui.dkhsqshclick) {
              list.push({ id: 'dkhsqshbtn2',  x:0, y:0, w:1, h:1, next: 'four_step11' })
            }
            return list
          }
        },
        {
          id: 'four_step10',
          stageBg: () => r('pddbg1.png'),
          image: () => r('order3.png'),
          canvasScale: 0.95,
          tip: '点击<span style="color: red;font-weight:bold;">发送文件</span>按钮',
          
          hotspots:[
            { id: 'fswjbtn', x: 0.49, y: 0.69, w: 0.02, h: 0.04, next: 'four_step11' }
          ]
        },
        {
          id: 'four_step11',
          stageBg: () => r('pddbg1.png'),
          image: () => r('order3.png'),
          canvasScale: 0.95,
          tip: '点击<span style="color: red;font-weight:bold;">小额打款</span>按钮',
          extraImages: ({ ui })  => {
            const list = []
            if (ui.ltjlclick2) {
               list.push({ id:'xedk', src: r('xedk.png'), x:0.28, y:0.14, w:0.435, h:0.74 })
            }
            return list
          },
          hotspots:({ ui })  => {
            const list = []
            list.push({ id: 'ltjlbtn2', x: 0.56, y: 0.69, w: 0.04, h: 0.04, set: { ltjlclick2: true } })
            if (ui.ltjlclick2) {
              list.push({ id: 'ltjlbtn3', x:0, y:0, w:1, h:1, next: 'four_step13' })
            }
            return list
          }
        },
        {
          id: 'four_step12',
          stageBg: () => r('pddbg1.png'),
          image: () => r('order3.png'),
          canvasScale: 0.95,
          tip: '点击<span style="color: red;font-weight:bold;">小额收款</span>按钮',
          extraImages: ({ ui })  => {
            const list = []
            if (ui.xeskclick) {
               list.push({ id:'xesk', src: r('xesk.png'),  x:0.32, y:0.33, w:0.33, h:0.29 })
            }
            return list
          },
          hotspots:({ ui })  => {
            const list = []
            if (!ui.xeskclick) {
              list.push({ id: 'xeskbtn', x: 0.60, y: 0.69, w: 0.04, h: 0.04, set: { xeskclick: true } })
            }
            if (ui.xeskclick) {
              list.push({ id: 'xeskbtn2',  x:0.31, y:0.33, w:0.33, h:0.29, next: 'four_step13' })
            }
            return list
          }
        },
        {
          id: 'four_step13',
          stageBg: () => r('pddbg1.png'),
          image: () => r('order3.png'),
          canvasScale: 0.95,
          tip: '点击查看<span style="color: red;font-weight:bold;">更多功能</span>',
          extraImages: ({ ui })  => {
            const list = []
            if (ui.moreHover) {
               list.push({ id:'moreHover', src: r('more_feature.png'), x:0.65, y:0.73, w:0.04, h:0.03,shadow: false })
            }
            if (ui.other1click) {
               list.push({ id:'other', src: r('other.png'),  x:0.58, y:0.72, w:0.10, h:0.20, shadow: false })
            }
            return list
          },
          hotspots:({ ui })  => {
            const list = []
            list.push({ id: 'otherbtn', x: 0.64, y: 0.69, w: 0.03, h: 0.04,hoverSet:{moreHover:true}, hoverUnset: { moreHover: false }, set: { other1click: true } })
            if (ui.other1click) {
              list.push({ id: 'otherbtn2',  x:0, y:0, w:1, h:1, next: 'four_step14' })
            }
            return list
          }
        },
        {
          id: 'four_step14',
          stageBg: () => r('pddbg1.png'),
          image: () => r('order3.png'),
          canvasScale: 0.95,
          tip: '点击数据面板的<span style="color: red;font-weight:bold;">展开</span>按钮，查看数据；',
          extraImages: ({ ui })  => {
            const list = []
            if (ui.sjmbclick) {
               list.push({ id:'sjmb', src: r('sjmb.png'),  x:0.31, y:0.06, w:0.36, h:0.46 })
            }
            return list
          },
          hotspots:({ ui })  => {
            const list = []
            list.push({ id: 'sjmbbtn', x: 0.63, y: 0.08, w: 0.03, h: 0.04, set: { sjmbclick: true } })
            if (ui.sjmbclick) {
              list.push({ id: 'sjmbbtn2',  x:0, y:0, w:1, h:1, next: 'four_step18' })
            }
            return list
          }
        },
        {
          id: 'four_step17',
          stageBg: () => r('pddbg1.png'),
          image: () => r('order3.png'),
          canvasScale: 0.95,
          tip: '<span style="color: red;font-weight:bold;">举报恶意客户</span>',
          extraImages: ({ ui })  => {
            const list = []
            if (ui.jb1click && !ui.jb2click) {
               list.push({ id:'jbalert', src: r('jbalert.png'), x:0.58, y:0.19, w:0.08, h:0.12 })
            }
            if (ui.jb2click) {
               list.push({ id:'jbeykh', src: r('jbeykh.png'), x:0.28, y:0.14, w:0.425, h:0.58 })
            }
            return list
          },
          hotspots:({ ui })  => {
            const list = []
            if (!ui.jb1click  && !ui.jb2click) {
              list.push({ id: 'jb1btn', x: 0.59, y: 0.15, w: 0.02, h: 0.04, set: { jb1click: true } })
            }
            if (ui.jb1click) {
              list.push({ id: 'jb2btn', x: 0.58, y: 0.19, w: 0.04, h: 0.04, set: { jb2click: true } })
            }
            if (ui.jb2click) {
              list.push({ id: 'ltjlbtn3', x:0.28, y:0.14, w:0.425, h:0.58, next: 'four_step18' })
            }
            return list
          }
        },
        {
          id: 'four_step18',
          stageBg: () => r('pddbg1.png'),
          image: () => r('order3.png'),
          canvasScale: 0.95,
          tip: '<span style="color: red;font-weight:bold;">转移会话</span>给<span style="color: red;font-weight:bold;">淘金云客服01</span>，原因选择<span style="color: red;font-weight:bold;">退款/退货问题</br>',
          extraImages: ({ ui })  => {
            const list = []
            if (ui.zy1click && !ui.zy2click) {
               list.push({ id:'zyhh1', src: r('zyhh1.png'), x:0.22, y:0.19, w:0.52, h:0.62 })
            }
            if (ui.zy2click && ui.zy1click) {
               list.push({ id:'zyhh1', src: r('zyhh2.png'), x:0.22, y:0.19, w:0.52, h:0.62 })
            }
            return list
          },
          hotspots:({ ui })  => {
            const list = []
            if (!ui.zy1click && !ui.zy2click) {
              list.push({ id: 'jb1btn', x: 0.62, y: 0.15, w: 0.02, h: 0.04, set: { zy1click: true } })
            }
            if (ui.zy1click && !ui.zy2click) {
              list.push({ id: 'jb2btn', x: 0.54, y: 0.39, w: 0.04, h: 0.04, set: { zy2click: true } })
            }
            if (ui.zy2click && ui.zy1click) {
              list.push({ id: 'ltjlbtn3', x:0.49, y:0.55, w:0.145, h:0.05, next: 'four_step19' })
            }
            return list
          }
        },
        {
          id: 'four_step19',
          stageBg: () => r('pddbg1.png'),
          image: () => r('undealuser.png'),
          canvasScale: 0.95,
          tip: '将此客户标为<span style="color: red;font-weight:bold;">黄色星星</span>，添加到收藏会话',
          extraImages: ({ ui })  => {
            const list = []
            if (ui.starclick) {
               list.push({ id:'tag', src: r('tag.png'),  x:0.58, y:0.19, w:0.09, h:0.05, shadow: false })
            }
            return list
          },
          hotspots:({ ui })  => {
            const list = []
            if (!ui.starclick) {
              list.push({ id: 'starbtn', x: 0.65, y: 0.15, w: 0.02, h: 0.04, hoverSet: { starclick: true } })
            }
            if (ui.starclick) {
              list.push({ id: 'xeskbtn2',  x:0.605, y:0.19, w:0.02, h:0.05, next: 'four_step20' })
            }
            return list
          }
        },
        {
          id: 'four_step20',
          stageBg: () => r('pddbg1.png'),
          image: () => r('dealuser.png'),
          canvasScale: 0.95,
          tip: '在<span style="color: red;font-weight:bold;">全部会话</span>中查看收藏的会话',
          extraImages: [{ id:'tagsuccess', src: r('tagsuccess.png'),  x:0.40, y:0.43, w:0.12, h:0.05 }],
          hotspots:[],
          afterEnter: { delay: 2500, go: 'four_step21' }
        },
        {
          id: 'four_step21',
          stageBg: () => r('pddbg1.png'),
          image: () => r('dealuser.png'),
          canvasScale: 0.95,
          tip: '在<span style="color: red;font-weight:bold;">全部会话</span>中查看收藏的会话',
          hotspots:[{ id: 'allchat',  x:0.17, y:0.2, w:0.06, h:0.05, next: 'four_step22' }],
        },
        {
          id: 'four_step22',
          stageBg: () => r('pddbg1.png'),
          image: () => r('allchat.png'),
          canvasScale: 0.95,
          tip: '取消<span style="color: red;font-weight:bold;">标星</span>',
          hotspots:[{ id: 'unstarbtn', x: 0.65, y: 0.15, w: 0.02, h: 0.04, next: 'four_step23' }],
        },
        {
          id: 'four_step23',
          stageBg: () => r('pddbg1.png'),
          image: () => r('untagsuccessbg.png'),
          canvasScale: 0.95,
          tip: '取消<span style="color: red;font-weight:bold;">标星</span>',
          extraImages: [{ id:'untagsuccess', src: r('untagsuccess.png'),  x:0.40, y:0.43, w:0.15, h:0.05 }],
          isEnd: true
        },
      ]
    },
    five: {
      initialStepId: 'five_1',
      initialForm: { remark:'' },
      steps: [
        {
          id: 'five_1',
          stageBg: () => r('pddbg1.png'),
          image: () => r('untagsuccessbg.png'),
          canvasScale: 0.95,
          tip: '【假设商家要求给<span style="color: red;font-weight:bold;">发顺丰</span>的客户标记<span style="color: red;font-weight:bold;">红色</span>】<span style="color: red;font-weight:bold;">请添加订单备注，并标记对应的颜色。</span><br>备注内容为：发顺丰',
          extraImages: ({ ui }) => { 
            const list = []
            if (ui.remarkClick && !ui.redClick) {
               list.push({ id:'orderremark', src: r('orderremark1.png'), x:0.68, y:0.26, w:0.26, h:0.50 })
            }
            if (ui.redClick) {
               list.push({ id:'orderremark', src: r('orderremark2.png'), x:0.68, y:0.26, w:0.26, h:0.50 })
            }
            return list
          },
          fields:({ ui }) => { 
            const list = []
            if (ui.redClick) {
               list.push({ id: 'remark', model: 'remark', type: 'text',bgColor: '#fff', placeholder: '请填写订单备注信息', x: 0.695, y: 0.42, w: 0.17, h: 0.05 })
            }else if(ui.remarkClick) {
                list.push({ id: 'remark', model: 'remark', type: 'text',bgColor: '#fff', placeholder: '请填写订单备注信息', x: 0.695, y: 0.39, w: 0.17, h: 0.05 })
            }
            return list
          },
          hotspots:({ ui }) => { 
            const list = []
            if (!ui.remarkClick && !ui.redClick) { 
              list.push({ id: 'orderremarkbtn', x: 0.89, y: 0.55, w: 0.04, h: 0.04, set: { remarkClick : true } })
            }
            if (ui.remarkClick && !ui.redClick) {
              list.push({ id: 'redbtn', x:0.69, y:0.33, w:0.03, h:0.04, set: { redClick: true } })
            }
            if (ui.redClick || ui.remarkClick) {
               list.push({ 
                id: 'redbtn', 
                x:0.84, y:0.71, w:0.05, h:0.04,
                guard: ({ form,ui }) => {
                  if (form.remark !== '发顺丰') return { ok: false, msg: '请备注发顺丰' }
                  if (!ui.redClick) {
                    return { ok: false, msg: '请标记红色' }
                  }
                  return { ok: true }
                },
                next:'five_2'
              })
            }
            return list
          }
        },
        {
          id: 'five_2',
          stageBg: () => r('pddbg1.png'),
          image: () => r('markend.png'),
          canvasScale: 0.95,
          tip: '点击<span style="color: red;font-weight:bold;">商品推荐</span>',
          hotspots: [
            { id: 'tjsptab', x:0.75, y:0.16, w:0.054, h:0.045, next: 'five_3' }
          ]
        },
        {
          id: 'five_3',
          stageBg: () => r('pddbg1.png'),
          image: () => r('tjsp2.png'),
          canvasScale: 0.95,
          extraImages: ({ ui }) => { 
            const list = []
            if (ui.tjstep == 'step_zuji') {
               list.push({ id:'llzj', src: r('llzj.png'), x:0.671, y:0.14, w:0.274, h:0.85, shadow: false})
            }else  if (ui.tjstep == 'step_rexiao') {
               list.push({ id:'rexiao', src: r('rexiao.png'), x:0.671, y:0.14, w:0.274, h:0.85, shadow: false})
            }else  if (ui.tjstep == 'step_caitaxihuan') {
               list.push({ id:'caitaxihuan', src: r('caitaxihuan.png'), x:0.671, y:0.14, w:0.274, h:0.85, shadow: false})
            }
            return list
          },
          tip: ({ui}) => {
            if(ui.tjstep == 'step_zuji') {
              return '查看<span style="color: red;font-weight:bold;">热销商品</span>'
            }else if(ui.tjstep == 'step_rexiao') {
              return '查看<span style="color: red;font-weight:bold;">猜TA喜欢</span>'
            }else if(ui.tjstep == 'step_caitaxihuan') {
              return '把<span style="color: red;font-weight:bold;">销量最高的</span>商品发送给客户'
            }
            return '查看<span style="color: red;font-weight:bold;">浏览足迹</span>'
          },

          hotspots:({ui}) => {
            const list = [
              { id: 'step_zuji', x:0.74, y:0.27, w:0.06, h:0.04, set: { tjstep: 'step_zuji' } },
              { id: 'step_rexiao', x:0.80, y:0.27, w:0.04, h:0.04, set: { tjstep: 'step_rexiao' } },
              { id: 'step_caitaxihuan', x:0.84, y:0.27, w:0.05, h:0.04, set: { tjstep: 'step_caitaxihuan' } }
            ]
            if(ui.tjstep == 'step_caitaxihuan') {
              list.push({ id: 'sendgoods', x:0.68, y:0.50, w:0.05, h:0.04, next: 'five_4' })
            }
            return list
          }
        },
        {
          id: 'five_4',
          stageBg: () => r('pddbg1.png'),
          image: () => r('tjsp2.png'),
          canvasScale: 0.95,
          extraImages: [
            { id:'caitaxihuan', src: r('caitaxihuan.png'), x:0.671, y:0.14, w:0.274, h:0.85, shadow: false},
            { id:'goodmsg', src: r('goodmsg.png'), x:0.38, y:0.38, w:0.27, h:0.29, shadow: false}
          ],
          tip: '',
          isEnd: true
        }
      ]
    },
    six: {
      initialStepId: 'six_1',
      initialForm: { groupName:'',kjbm:'',kjdy:'',srnr: '' },
      steps: [
        {
          id: 'six_1',
          stageBg: () => r('pddbg1.png'),
          image: () => r('tjsp2.png'),
          canvasScale: 0.95,
          tip:({ui}) => {
            if(!ui.six_stp) {
              return '点击<span style="color: red;font-weight:bold;">快捷回复</span>'
            }else if(ui.six_stp == 'show_kjhf1') {
              return '<span style="color: red;font-weight:bold;">添加</span>一条快捷回复'
            }else if(ui.six_stp == 'add_kjhf' || ui.six_stp == 'add_group') {
              return '新增分组名称为<br><span style="color: red;font-weight:bold;">常用接待语</span>'
            }else if(ui.six_stp == 'add_group_success' || ui.six_stp == 'select_group' || ui.six_stp == 'selected_group') {
              return '选择刚才新建的分组<br>新建快捷编码为<span style="color: red;font-weight:bold;">欢迎</span><br>话术内容为<span style="color: red;font-weight:bold;">欢迎光临小店，很高兴为您服务~</span>的快捷回复'
            }
            return ''
          },
          extraImages: ({ui}) => {
            const list = []
            if (ui.six_stp == 'show_kjhf1') {
               list.push({ id:'kjhf', src: r('kjhf1.jpeg'), x:0.671, y:0.14, w:0.274, h:0.86, shadow: false})
            }
            if (ui.six_stp == 'add_kjhf') {
               list.push({ id:'kjhf', src: r('kjhf_add.jpeg'), x:0.671, y:0.14, w:0.274, h:0.86, shadow: false})
            }
            if (ui.six_stp == 'add_group') {
               list.push({ id:'kjhf', src: r('kjhf_add_group.jpeg'), x:0.671, y:0.14, w:0.274, h:0.86, shadow: false})
            }
            if (ui.six_stp == 'add_group_success') {
               list.push({ id:'kjhf', src: r('kjhf_add_group_success.jpeg'), x:0.671, y:0.14, w:0.274, h:0.86, shadow: false})
            }
            if (ui.six_stp == 'select_group') {
               list.push({ id:'kjhf', src: r('kjhf_add_select_group.jpeg'), x:0.671, y:0.14, w:0.274, h:0.86, shadow: false})
            }
            if (ui.six_stp == 'selected_group') {
               list.push({ id:'kjhf', src: r('kjhf_add_new.jpeg'), x:0.671, y:0.14, w:0.274, h:0.86, shadow: false})
            }
            return list
          },
          fields: ({ui}) => {
            const list = []
            if (ui.six_stp == 'add_group') {
               list.push({ id: 'groupName', model: 'groupName', type: 'text',bgColor: '#fff', placeholder: '请输入分组名称', x: 0.70, y: 0.52, w: 0.215, h: 0.032 },)
            }
            if (ui.six_stp == 'selected_group' || ui.six_stp == 'add_group_success') {
              list.push({ id: 'kjbm', model: 'kjbm', type: 'text',bgColor: '#fff', placeholder: '支持大小写字母、数字和汉字', x: 0.70, y: 0.54, w: 0.215, h: 0.032 },)
              list.push({ id: 'kjdy', model: 'kjdy', type: 'text',bgColor: '#fff', placeholder: '请输入话术内容', x: 0.70, y: 0.62, w: 0.215, h: 0.032 },)
            }
            return list
          },
          hotspots: ({ui}) => {
            const list = []
            if (!ui.six_stp) {
              list.push({ id: 'kjhfbtn', x:0.82, y:0.16, w:0.05, h:0.04, set: { six_stp: 'show_kjhf1' } })
            }
            if (ui.six_stp == 'show_kjhf1') {
              list.push({ id: 'addbtn', x:0.72, y:0.95, w:0.05, h:0.04, set: { six_stp: 'add_kjhf' } })
            }
            if (ui.six_stp == 'add_kjhf') {
              list.push({ id: 'addgroup', x:0.87, y:0.42, w:0.05, h:0.04, set: { six_stp: 'add_group' } })
            }
            if (ui.six_stp == 'add_group') {
              list.push({ 
                id: 'confirmaddgroup', 
                x:0.83, y:0.57, w:0.05, h:0.04, 
                guard: ({ form }) => {
                  console.log('ssss' + form.groupName)
                  if (form.groupName !== '常用接待语') return { ok: false, msg: '请输入正确的分组名称' }
                  return { ok: true }
                },
                set: { six_stp: 'add_group_success' }
              })
            }
            if (ui.six_stp == 'add_group_success') { 
              list.push({ id: 'selectgroup', x:0.70, y:0.45, w:0.22, h:0.04, set: { six_stp: 'select_group' } })
            }
            if (ui.six_stp == 'select_group') { 
              list.push({ id: 'selectgroup1', x:0.70, y:0.57, w:0.22, h:0.04, set: { six_stp: 'selected_group' } })
            }
            if (ui.six_stp == 'selected_group') { 
              list.push({ 
                id: 'confirmadd', 
                x:0.84, y:0.73, w:0.04, h:0.04, 
                guard: ({ form }) => {
                  console.log('ssss' + form.groupName)
                  if (form.kjbm !== '欢迎') return { ok: false, msg: '请输入正确的快捷编码' }
                  if (form.kjdy !== '欢迎光临小店，很高兴为您服务~') return { ok: false, msg: '请输入正确的分组名称' }
                  return { ok: true }
                },
                next: 'six_1a'
              })
            }
            return list
          }
        },
        {
          id: 'six_1a',
          stageBg: () => r('pddbg1.png'),
          image: () => r('tjsp2.png'),
          extraImages: ({ui}) => {
            const list = []
            list.push({ id:'add_kjdy_success', src: r('add_kjdy_success.png'), x:0.671, y:0.14, w:0.274, h:0.86, shadow: false})
            return list
          },
          canvasScale: 0.95,
          tip: '选择刚才新建的分组<br>新建快捷编码为<span style="color: red;font-weight:bold;">欢迎</span><br>话术内容为<span style="color: red;font-weight:bold;">欢迎光临小店，很高兴为您服务~</span>的快捷回复',
          afterEnter: { delay: 2500, go: 'six_2' } 
        },
        {
          id: 'six_2',
          stageBg: () => r('pddbg1.png'),
          image: () => r('tjsp2.png'),
          canvasScale: 0.95,
          tip: '采用输入<span style="color: red;font-weight:bold;">/</span>+<span style="color: red;font-weight:bold;">快捷编码</span>的方式，给客户发送欢迎语',
          fields: () => {
            const list = []
            list.push({
              id: 'srnr',
              model: 'srnr',
              type: 'text',
              bgColor: '#fff',
              placeholder: '请输入内容',
              x: 0.32, y: 0.79, w: 0.295, h: 0.032,
              onInput: ({ value, setUi }) => {
                if (String(value || '').trim() === '/欢迎') {
                  setUi({ six_stp: 'show_tip' })
                }else{
                  setUi({ six_stp: '' })
                }
              },
              onEnter: ({ form, go, setForm, set}) => {
                if (String(form.srnr || '').trim() === '欢迎光临小店，很高兴为您服务~') {
                  go('six_3') // 或者你想跳的 stepId
                }else if (String(form.srnr || '').trim() === '/欢迎'){
                  setForm({ srnr: '欢迎光临小店，很高兴为您服务~' })
                  set({ six_stp : 'click_tip_done' })
                }
              }
            })
            return list
          },
          extraImages: ({ui}) => {
            const list = []
            list.push({ id:'kjdy_raw', src: r('kjdy_raw.png'), x:0.671, y:0.14, w:0.274, h:0.86, shadow: false})
            if (ui.six_stp == 'show_tip') {
                list.push({ id: 'kjhf_alert', src: ui.tipHover ? r('kjdy_alert_hover.png') : r('kjdy_alert.png'), x:0.35, y:0.825, w:0.38,h:0.0415, shadow: false})
            }
            return list
          },
          hotspots: ({ui,form}) => {
            const list = []
            if (ui.six_stp == 'show_tip') {
              list.push(
                { 
                  id: 'select_kjdy', x:0.35, y:0.825, w:0.38,h:0.0415, 
                  hoverSet: { tipHover: true }, hoverUnset: { tipHover: false }, 
                  setForm: { srnr: '欢迎光临小店，很高兴为您服务~' },
                  set: { six_stp : 'click_tip_done'},
                  focusFieldId: 'srnr'
                }
              )
            }
            if (ui.six_stp == 'click_tip_done') {
              list.push(
                { 
                  id: 'send_kjdy', x:0.61, y:0.945, w:0.06,h:0.0415, 
                  next: 'six_3'
                }
              )
            }
            return list
          }
        },
        {
          id: 'six_3',
          stageBg: () => r('pddbg1.png'),
          image: () => r('tjsp2.png'),
          extraImages: ({ui}) => {
            const list = []
            list.push({ id:'kjdy_raw', src: r('kjdy_raw.png'), x:0.671, y:0.14, w:0.274, h:0.86, shadow: false})
            list.push({ id: 'send_kjdy', src: r('send_kjdy.png'), x:0.35, y:0.26, w:0.31,h:0.33, shadow: false})
            return list
          },
          canvasScale: 0.95,
          tip: '输入<span style="color: red;font-weight:bold;">/</span>+<span style="color: red;font-weight:bold;">快捷编码</span>发送快捷回复给客户',
          afterEnter: { delay: 2500, go: 'six_4' } 
        },
        {
          id: 'six_4',
          stageBg: () => r('pddbg1.png'),
          image: () => r('tjsp2.png'),
          extraImages: ({ui}) => {
            const list = []
            if (!ui.six_dr_stp) {
              list.push({ id:'kjdy_raw', src: r('kjdy_raw.png'), x:0.671, y:0.14, w:0.274, h:0.86, shadow: false})
            }
            if (ui.six_dr_stp == 'six_drdc') {
              list.push({ id:'kjdy_raw', src: r('kjdy_drdc.jpeg'), x:0.671, y:0.14, w:0.274, h:0.86, shadow: false})
            }
            if (ui.six_dr_stp == 'six_drdc_dr') {
              list.push({ id:'kjdy_raw', src: r('kjdy_raw.png'), x:0.671, y:0.14, w:0.274, h:0.86, shadow: false})
              list.push({ id:'dr_alert1', src: r('dr_alert1.png'), x:0.29, y:0.26, w:0.41, h:0.39, shadow: true})
            }
            return list
          },
          canvasScale: 0.95,
          tip: '请<span style="color: red;font-weight:bold;">先下载</span>快捷短语表格<span style="color: red;font-weight:bold;">并保存到桌面上</span>，再<span style="color: red;font-weight:bold;">导入</span>快捷短语。',
          hotspots:({ui}) => {
            const list = []
            if (!ui.six_dr_stp) {
              list.push({ id: 'drdc', x: 0.82, y: 0.96, w: 0.11, h: 0.04, set:{ six_dr_stp:'six_drdc' } })
            }
            if (ui.six_dr_stp == 'six_drdc') {
              list.push({ id: 'drbtn', x: 0.82, y: 0.81, w: 0.11, h: 0.04, set:{ six_dr_stp:'six_drdc_dr' } })
              list.push({ id: 'xzbtn', x: 0.82, y: 0.90, w: 0.11, h: 0.04, emit: 'download-file' })
            }
            if (ui.six_dr_stp == 'six_drdc_dr') {
              list.push({ id: 'six_drdc_dr', x: 0.40, y: 0.42, w: 0.11, h: 0.04, emit: 'request-file' })
            }
            return list
          }
        },
        {
          id: 'six_5',
          stageBg: () => r('pddbg1.png'),
          image: () => r('tjsp2.png'),
          canvasScale: 0.95,
          tip: '请<span style="color: red;font-weight:bold;">先下载</span>快捷短语表格<span style="color: red;font-weight:bold;">并保存到桌面上</span>，再<span style="color: red;font-weight:bold;">导入</span>快捷短语。',
          extraImages: ({ui}) => {
            const list = []
            list.push({ id:'six_5a', src: r('kjdy_raw.png'), x:0.671, y:0.14, w:0.274, h:0.86, shadow: false})
            if (!ui.six_dr_alert) {
              list.push({ id:'six_5b', src: r('dr_alert1a.png'), x:0.29, y:0.26, w:0.41, h:0.39, shadow: true})
            }else if (ui.six_dr_alert == 'six_drdc_dr_confirm') {
              list.push({ id:'six_5c', src: r('dr_alert2.png'), x:0.29, y:0.26, w:0.41, h:0.39, shadow: true})
            }
            return list
          },
          hotspots:({ui}) => {
            const list = []
            if (!ui.six_dr_alert) {
              list.push({ id: 'six_5d', x: 0.52, y: 0.57, w: 0.09, h: 0.04, set:{ six_dr_alert:'six_drdc_dr_confirm' } })
            }else if (ui.six_dr_alert == 'six_drdc_dr_confirm') {
              list.push({ id: 'six_5f', x: 0.66, y: 0.28, w: 0.03, h: 0.04, next:'six_done' })
              list.push({ id: 'six_5e', x: 0.61, y: 0.57, w: 0.06, h: 0.04, next:'six_done' })
            }
            return list
          }
        },
        {
          id: 'six_done',
          stageBg: () => r('pddbg1.png'),
          image: () => r('tjsp2.png'),
          canvasScale: 0.95,
          extraImages:[{ id:'six_done_a', src: r('kjdy_dr_done.jpeg'), x:0.671, y:0.14, w:0.274, h:0.86, shadow: false}],
          isEnd: true
        }
      ]
    },
    seven: {
      initialStepId: 'seven_1',
      initialForm: { },
      steps: [
        {
          id: 'seven_1',
          stageBg: () => r('pddbg1.png'),
          image: () => r('statusonline.png'),
          canvasScale: 0.95,
          tip: '切换接待状态为<span style="color: red;font-weight:bold;">离线</span>',
          extraImages: ({ ui }) => {
            const list = []
            if (ui.offlineClick) {
              list.push({ id:'seven_1a', src: r('staus.png'), x:0.13, y:0.1, w:0.06, h:0.1 })
            }
            return list
          },
          hotspots:({ ui }) => { 
            const list = []
            if (!ui.offlineClick) {
               list.push({ id: 'seven_1b', x: 0.13, y: 0.1, w: 0.04, h: 0.03, set: { offlineClick: true } })
            }
            if (ui.offlineClick) {
               list.push({ id: 'seven_1c', x: 0.13, y: 0.17, w: 0.06, h: 0.03, next: 'seven_2' })
            }
            return list
          }
        },
        {
          id: 'seven_2',
          stageBg: () => r('pddbg1.png'),
          image: () => r('loginindex.png'),
          canvasScale: 0.95,
          tip: '关闭接待窗口',
          hotspots: [
            { id: 'seven_1d', x: 0.93, y: 0.01, w: 0.02, h: 0.03, next: 'seven_3' }          
          ]
        },
        {
          id: 'seven_3',
          stageBg: () => r('pddbg1.png'),
          tip: '点击右下角任务栏，退出拼多多接待工具',
          extraImages:({ui}) => {
            const list = []
            list.push({ id:'seven_3a', src: r('status_bar_left.png'), x:0.0, y:0.957, w:0.84, h:0.04 })
            list.push({ id:'seven_3b', src: r('status_bar_right.png'), x:0.84, y:0.957, w:0.16, h:0.04 })
            if (ui.seven_3_step == 'menus_normal' || ui.seven_3_step == 'menus_right_click') {
              list.push({ id:'seven_3d', src: ui.pddHover ? r('status_menu2.png') : r('status_menu1.png'), x:0.74, y:0.81, w:0.11, h:0.15 })
            }
            if (ui.seven_3_step == 'menus_right_click') {
              list.push({ id:'seven_3f', src: r('quitpdd.png'), x:0.73, y:0.71, w:0.07, h:0.20 })
            }

            return list;
          },
          hotspots:({ui}) => {
            const list = []
            if (!ui.seven_3_step) {
              list.push({ id: 'seven_3c', x: 0.835, y: 0.96, w: 0.02, h: 0.03, set: {seven_3_step : 'menus_normal'} })
            }else if (ui.seven_3_step == 'menus_normal') {
              list.push({ id: 'seven_3e', x: 0.80, y: 0.92, w: 0.02, h: 0.03,on: 'contextmenu',  hoverUnset: { pddHover: false}, hoverSet: {pddHover:true}, set: {seven_3_step : 'menus_right_click'} })
            }else if (ui.seven_3_step == 'menus_right_click') {
                list.push({ id: 'seven_3g', x:0.73, y:0.71, w:0.07, h:0.20, next:'seven_done' })
            }
            return list
          }
        },
        {
          id: 'seven_done',
          stageBg: () => r('pddbg1.png'),
          isEnd: true 
        }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/simulate/pddStudyScenarios.js